// extracted by mini-css-extract-plugin
module.exports = {"oversiktFilter":"OversiktFilterBase_oversiktFilter__3a09O","filterWrapper":"OversiktFilterBase_filterWrapper__zK64w","filterButton":"OversiktFilterBase_filterButton__A5Yj3"};